import React, { useEffect, useRef } from 'react';
import { 
  RiDeleteBin6Line, 
  RiEdit2Line, 
  RiEyeLine,
  RiSearchLine,
  RiFilterLine,
  RiMore2Line,
  RiRefreshLine
} from 'react-icons/ri';
import { 
  FiSearch, 
  FiFilter, 
  FiEye, 
  FiEdit2, 
  FiTrash2, 
  FiToggleLeft, 
  FiToggleRight,
  FiCheckCircle,
  FiXCircle,
  FiUser,
  FiDollarSign,
  FiClock,
  FiTag,
  FiRefreshCw,
  FiMoreVertical,
  FiArrowUp,
  FiArrowDown,
  FiTrendingUp,
  FiTrendingDown,
  FiPercent,
  FiCalendar
} from "react-icons/fi";
import { 
  MdOutlineSearch, 
  MdOutlineFilter, 
  MdOutlineVisibility,
  MdOutlineEdit,
  MdOutlineDelete,
  MdOutlinePerson,
  MdOutlineAttachMoney,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending
} from "react-icons/md";
import ReactPaginate from 'react-paginate';
import moment from 'moment/moment';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import SortableHeader from '../../../components/SortableHeader';

const ReferalTable = ({
  TableName,
  TableHeader,
  TableData,
  showMenu,
  deleteAction,
  handleToggle,
  keyword,
  setKeyword,
  pageNo,
  handleChange,
  viewAction,
  handleFilter,
  handleFilter1,
  setpageNo,
  size,
  setSize, 
  total, 
  handlePageClick,
  currentSortKey,
  currentSortOrder,
  onSort
}) => {
  const ContentActionRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ContentActionRef.current && !ContentActionRef.current.contains(event.target)) {
        showMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  // Status badge component
  const StatusBadge = ({ isBlocked }) => {
    if (!isBlocked) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
          <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
          Active
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full">
        <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
        Disabled
      </span>
    );
  };

  // Payment provider badge
  const ProviderBadge = ({ user }) => {
    if (user?.isFlutterwaveVerified) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-full">
          <FiTag className="w-3.5 h-3.5 text-blue-500" />
          Flutterwave
        </span>
      );
    } else if (user?.isStripeVerified) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-purple-700 bg-purple-50 border border-purple-200 rounded-full">
          <FiTag className="w-3.5 h-3.5 text-purple-500" />
          Stripe
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-gray-600 bg-gray-50 border border-gray-200 rounded-full">
        N/A
      </span>
    );
  };

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
              <FiUser className="w-4 h-4 text-[#715EFE]" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-800">{TableName}</h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                {TableData?.length || 0} withdrawal requests
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            {/* Search */}
            <div className="relative flex-1 sm:min-w-[180px]">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search by user name..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              />
            </div>

            {/* Status Filter */}
            <div className="relative min-w-[130px]">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FiFilter className="text-gray-400 w-4 h-4" />
              </div>
              <select
                className="appearance-none w-full h-10 pl-9 pr-8 py-2 bg-white border border-gray-200 text-sm text-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                onChange={handleFilter}
              >
                <option value="">All Status</option>
                <option value={false}>Active</option>
                <option value={true}>Disabled</option>
              </select>
              <FiClock className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                {TableHeader.map((heading, index) => {
                  const headerIcons = {
                    '#id': null,
                    'User': FiUser,
                    'Balance': FiDollarSign,
                    'Pending Balance': FiClock,
                    'Payment Provider': FiTag,
                    'Status': FiCheckCircle,
                    'Date': FiCalendar,
                    'Action': null
                  };
                  const Icon = headerIcons[heading.label] || headerIcons[heading.label?.trim()];
                  return (
                    <th key={index} className="px-3 md:px-4 py-3 whitespace-nowrap">
                      <SortableHeader
                        label={heading.label}
                        sortKey={heading.sortKey}
                        currentSortKey={currentSortKey}
                        currentSortOrder={currentSortOrder}
                        onSort={onSort}
                        icon={Icon}
                      />
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {TableData && TableData.length > 0 ? (
                TableData.map((ele, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors duration-150 group">
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-medium text-gray-400">
                        {(pageNo - 1) * size + index + 1
                      }</span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#715EFE]">
                            {ele.userInfo?.fullName?.charAt(0)?.toUpperCase() || 'U'}
                          </span>
                        </div>
                        <span className="text-sm font-medium text-gray-800 truncate max-w-[120px]">
                          {ele.userInfo?.fullName || '-'}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-semibold text-emerald-600">
                        ${ele?.availableBalance?.toFixed(2) || '0.00'}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-semibold text-amber-600">
                        ${ele?.pendingBalance?.toFixed(2) || '0.00'}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <ProviderBadge user={ele?.userInfo} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <StatusBadge isBlocked={ele?.isBlocked} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-700 whitespace-nowrap">
                          {ele?.createdAt ? moment(ele.createdAt).format('MMM D, YYYY') : '-'}
                        </span>
                        {ele?.createdAt && (
                          <span className="text-xs text-gray-400">
                            {moment(ele.createdAt).format('h:mm A')}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <button
                        className="p-1.5 text-blue-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200"
                        onClick={() => viewAction(ele)}
                        title="View Details"
                      >
                        <FiEye className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={TableHeader.length} className="px-4 py-12 text-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-gray-50 rounded-full">
                        <FiUser className="w-10 h-10 text-gray-300" />
                      </div>
                      <p className="text-sm font-medium text-gray-500">No withdrawal requests found</p>
                      <p className="text-xs text-gray-400">Try adjusting your search or filters</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile View for Small Screens */}
        <div className="md:hidden divide-y divide-gray-100">
          {TableData && TableData.length > 0 ? (
            TableData.map((ele, index) => (
              <div key={index} className="p-4 hover:bg-gray-50/70 transition-colors duration-150">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-medium text-gray-400">
                      #{(pageNo - 1) * size + index + 1}
                    </span>
                    <StatusBadge isBlocked={ele?.isBlocked} />
                  </div>
                  <div className="flex items-center gap-1">
                    <button
                      className="p-1.5 text-blue-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg"
                      onClick={() => viewAction(ele)}
                    >
                      <FiEye className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">User</span>
                    <span className="text-sm font-semibold text-gray-800">
                      {ele.userInfo?.fullName || '-'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Balance</span>
                    <span className="text-sm font-semibold text-emerald-600">
                      ${ele?.availableBalance?.toFixed(2) || '0.00'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Pending</span>
                    <span className="text-sm font-semibold text-amber-600">
                      ${ele?.pendingBalance?.toFixed(2) || '0.00'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Provider</span>
                    <ProviderBadge user={ele?.userInfo} />
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Date</span>
                    <span className="text-sm text-gray-700">
                      {ele?.createdAt ? moment(ele.createdAt).format('MMM D, YYYY') : '-'}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-8 text-center">
              <div className="flex flex-col items-center gap-2">
                <FiUser className="w-10 h-10 text-gray-300" />
                <p className="text-sm text-gray-500">No withdrawal requests found</p>
              </div>
            </div>
          )}
        </div>

        {/* Pagination */}
        {total > size && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-100 bg-gray-50/50">
            <div className="text-sm text-gray-500">
              Showing {((pageNo - 1) * size) + 1} to {Math.min(pageNo * size, total)} of {total} entries
            </div>
            <ReactPaginate
              previousLabel={'Prev'}
              nextLabel={'Next'}
              breakLabel={'...'}
              breakClassName={'px-2 text-gray-400'}
              pageCount={Math.ceil(total / size)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={'flex items-center gap-1'}
              pageClassName={'px-2'}
              pageLinkClassName={'px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200'}
              previousClassName={'px-2'}
              previousLinkClassName={'px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200'}
              nextClassName={'px-2'}
              nextLinkClassName={'px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200'}
              activeClassName={'bg-[#715EFE] text-white rounded-md'}
              activeLinkClassName={'bg-[#715EFE] text-white px-3 py-1 rounded-md'}
              disabledClassName={'opacity-50 cursor-not-allowed'}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferalTable;